var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgBankIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.9995 37.6563H37.5777V32.9689H35.234V16.4849H37.5777V11.7975H39.9995V7.46873L20 0L0.000488281 7.46873V11.7975H2.42231V16.4849H4.766V32.9689H2.42231V37.6563H0.000488281V40H39.9995V37.6563ZM32.8903 32.9689H30.5466V16.4849H32.8903V32.9689ZM16.4845 16.4849V32.9689H11.7971V16.4849H16.4845ZM18.8282 16.4849H21.1719V32.9689H18.8282V16.4849ZM23.5156 16.4849H28.203V32.9689H23.5156V16.4849ZM2.34418 9.45384V9.09525L20 2.50182L37.6559 9.09525V9.45384H2.34418ZM35.234 11.7975V14.1412H4.766V11.7975H35.234ZM9.45339 16.4849V32.9689H7.1097V16.4849H9.45339ZM4.766 35.3126H35.234V37.6563H4.766V35.3126Z",
    fill: "#42586E"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBankIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/BankIcon.57f9abd7.svg";
export { ForwardRef as ReactComponent };